export class GetSupplierRevolutData {
    public supplierId: string;
}
